import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

declare let require: {
  (path: string): any;
};

if (environment.production) {
  enableProdMode();

  Sentry.init({
    dsn: 'https://6894a2c29f8d4d46b4bbc2bfd30315ee@sentry.behold.dev/5',
    enableLogs: true,
    environment: environment.name,
    release: `adey-web-portal@${require('../package.json').version}`,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    tracesSampleRate: 0.1,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
  });
}

platformBrowserDynamic().bootstrapModule(AppModule);
